import * as React from 'react';
import BetaBadge from './BetaBadge';

export const betaBadge = () => <BetaBadge />;

export default {
    title: 'Components/Badges/BetaBadge',
    component: BetaBadge,
};
